<!-- Два корня у хоста: np-strip + p-toast — у :host должен быть row flex, иначе блоки станут двумя строками -->
<div class="np-strip bb-np-strip">
  <div class="np-search min-w-0">
    <crm-global-search
      toolbarLayout="bottomBar"
      searchPlaceholder="Быстрый поиск…"></crm-global-search>
  </div>

  <div
    class="np-divider"
    aria-hidden="true"></div>

  <div class="np-badges flex align-items-center flex-shrink-0">
    <crm-notification-list
      *ngIf="listShowNotification.includes(NotificationKind.PURCHASE)"
      icon="pi-table"
      header="Закупки"
      [informerType]="NotificationKind.PURCHASE"></crm-notification-list>
    <crm-notification-task-list
      *ngIf="listShowNotification.includes(NotificationKind.TASK) && access.canReadBrsTask"
      icon="pi-dollar"
      header="Платежи"></crm-notification-task-list>
    <crm-notification-list
      *ngIf="listShowNotification.includes(NotificationKind.PROJECT) && access.canReadProject"
      icon="pi-check-square"
      header="Задачи"
      [informerType]="NotificationKind.PROJECT"></crm-notification-list>
    <crm-notification-list
      *ngIf="listShowNotification.includes(NotificationKind.PERSONAL)"
      icon="pi-user"
      header="Личные"
      [informerType]="NotificationKind.PERSONAL"></crm-notification-list>
    <crm-notification-list
      *ngIf="listShowNotification.includes(NotificationKind.HELPDESK)"
      icon="pi-question-circle"
      header="HelpDesk"
      [informerType]="NotificationKind.HELPDESK"></crm-notification-list>
    <crm-notification-list
      *ngIf="listShowNotification.includes(NotificationKind.DEBT) && access.canReadMailing"
      icon="pi-info-circle"
      header="Задолженности"
      [informerType]="NotificationKind.DEBT"></crm-notification-list>
    <crm-notification-list
      *ngIf="listShowNotification.includes(NotificationKind.DEAL) && access.canReadDeal"
      icon="pi-briefcase"
      header="Сделки"
      [informerType]="NotificationKind.DEAL"></crm-notification-list>
    <crm-notification-expired-list *ngIf="isShowExpiredNotification"></crm-notification-expired-list>
  </div>

  <div
    class="np-divider"
    aria-hidden="true"></div>

  <div class="np-actions flex align-items-center flex-shrink-0">
    <crm-notification-favorites-list *ngIf="listShowNotification.includes(NotificationKind.PROJECT)"></crm-notification-favorites-list>
    <crm-support-modal></crm-support-modal>
    <crm-voice-assistant-modal></crm-voice-assistant-modal>
  </div>
</div>

<p-toast
  key="notification"
  position="bottom-right"
  styleClass="notification-toast"
  #toast>
  <ng-template
    let-message
    pTemplate="message">
    <div
      *ngIf="toSocketNotification(message.data) as notification"
      class="w-full cursor-pointer"
      (click)="onNotificationClick(toast, notification)">
      <h4 class="mt-0 mb-3 font-bold">{{ notification.subject?.title || 'Новое уведомление' }}</h4>
      <h4
        *ngIf="
          notification?.user?.profile?.name ||
          notification?.externalUser?.profile?.name ||
          notification.subject?.title !== 'Сервисное уведомление'
        "
        class="mt-0 mb-1 font-medium">
        {{ notification?.user?.profile?.name || notification?.externalUser?.profile?.name || 'Сервисное уведомление' }}
      </h4>
      <p
        class="notification-text break-word"
        [innerHTML]="notification.text | truncate: 70 | safeHtml"></p>
    </div>
  </ng-template>
</p-toast>
